import { useEffect, useState, FC } from 'react';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import { createRoot } from 'react-dom/client';
import { theme } from 'bs-unified-ui';
import CustomDialog from './CustomDialog';
import UnifiedErrorDialog from './UnifiedErrorDialog';
import UnifiedConfirmDialog from './UnifiedConfirmDialog';

interface DialogContentProps {
  [key: string]: any;
}

const DialogContent: FC<DialogContentProps> = (props) => {
  const [open, setOpen] = useState(true);

  useEffect(() => {
    setOpen(true);
  }, [props]);

  const close = () => {
    setOpen(false);
  };

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <CustomDialog open={open} onClose={close} {...props} />
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

const UnifiedErrorDialogContent: FC<DialogContentProps> = (props) => {
  const [open, setOpen] = useState(true);

  useEffect(() => {
    setOpen(true);
  }, [props]);

  const onClose = () => {
    setOpen(false);
  };

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <UnifiedErrorDialog open={open} onClose={onClose} {...props} />
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

const UnifiedConfirmDialogContent: FC<DialogContentProps> = (props) => {
  const [open, setOpen] = useState(true);

  useEffect(() => {
    setOpen(true);
  }, [props]);

  const onClose = () => {
    setOpen(false);
  };

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <UnifiedConfirmDialog open={open} onClose={onClose} {...props} />
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

const showDialog = (props: DialogContentProps) => {
  const root = createRoot(document.getElementById('errorMessage')!);
  root.render(<DialogContent {...props} />);
};

const showErrorDialog = (props: DialogContentProps) => {
  const root = createRoot(document.getElementById('errorMessage')!);
  root.render(<UnifiedErrorDialogContent {...props} />);
};

const showConfirmDialog = (props: DialogContentProps) => {
  const root = createRoot(document.getElementById('errorMessage')!);
  root.render(<UnifiedConfirmDialogContent {...props} />);
};

export { showDialog, showErrorDialog, showConfirmDialog };
